import { AdminApiClient } from '@guiker/payout-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useAdminPayoutApiClient = useAuthenticatedApiClient(AdminApiClient)
